import { ErrorMessage } from "formik";
import React from "react";

export default function CustomErrorMessage(props) {
  return (
      <ErrorMessage name={props.name} component="p" className="MuiFormHelperText-root Mui-error"/>
  );
}